import directive from './angular-jsoneditor.directive';

export default angular.module('angular-jsoneditor', []).directive('angularJsoneditor', directive);



// WEBPACK FOOTER //
// ./src/index.js